import { defineComponent as w, computed as v, useAttrs as y, createBlock as C, openBlock as b, unref as l, normalizeStyle as k, normalizeClass as N, withCtx as i, createVNode as r, Transition as O, withDirectives as $, mergeProps as B, withKeys as S, renderSlot as d, vShow as K, normalizeProps as M, guardReactiveProps as P } from "vue";
import "@popperjs/core";
import { RevList as R } from "@ds/components/List";
import "@ds/components/ListItemInteractive";
import { RevPopover as z } from "@ds/components/Popover";
import { omit as A } from "../../utils/omit.js";
import { tw as t } from "../../utils/tailwind.js";
const j = /* @__PURE__ */ w({
  name: "RevContextualMenu",
  inheritAttrs: !1,
  __name: "ContextualMenu",
  props: {
    disabled: { type: Boolean, default: !1 },
    listClassNames: { default: "" },
    contentClassNames: { default: "" },
    modifiers: { default: void 0 },
    position: { default: "auto" },
    role: { default: "menu" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 }
  },
  emits: ["keydown"],
  setup(m) {
    const u = m, f = {
      role: "menuitem"
    }, p = v(() => A(y(), ["class", "style"]));
    function c(e, s) {
      e && s();
    }
    const h = (e) => {
      const s = e.split("-", 1)[0], o = {
        bottom: t`origin-top`,
        left: t`origin-right`,
        right: t`origin-left`,
        top: t`origin-bottom`
      }[s];
      return [
        t`bg-overlap-default-low shadow-long rounded-sm inline-block min-w-240 max-w-320 overflow-y-auto`,
        o,
        u.listClassNames
      ];
    };
    return (e, s) => (b(), C(l(z), {
      class: N(e.$attrs.class),
      "content-class-names": e.contentClassNames,
      modifiers: e.modifiers,
      position: e.position,
      "should-hide-on-click-outside": e.shouldHideOnClickOutside,
      "should-show-on-mount": e.shouldShowOnMount,
      style: k(e.$attrs.style),
      "trigger-element-id": e.triggerElementId
    }, {
      trigger: i((o) => [
        d(e.$slots, "trigger", M(P({ ...o, isOpen: o.isOpen && !e.disabled })))
      ]),
      content: i(({ hide: o, isOpen: a, position: g }) => [
        r(O, {
          appear: "",
          "enter-active-class": "motion-safe:duration-300 motion-safe:ease-out",
          "enter-from-class": "scale-0 opacity-0",
          "leave-active-class": "motion-safe:duration-300 motion-safe:ease-in",
          "leave-to-class": "scale-0 opacity-0"
        }, {
          default: i(() => [
            $(r(l(R), B({
              "aria-expanded": a && !e.disabled,
              class: h(g),
              "has-external-borders": !1,
              role: e.role
            }, p.value, {
              onKeydown: [
                (n) => e.$emit("keydown", n, o),
                S((n) => c(a, o), ["esc"])
              ]
            }), {
              default: i(() => [
                d(e.$slots, "items", {
                  attrs: f,
                  hide: o
                })
              ]),
              _: 2
            }, 1040, ["aria-expanded", "class", "role", "onKeydown"]), [
              [K, a && !e.disabled]
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }, 8, ["class", "content-class-names", "modifiers", "position", "should-hide-on-click-outside", "should-show-on-mount", "style", "trigger-element-id"]));
  }
});
export {
  j as default
};
